import InstantLuckyDrawTemplateForm from "./instantLuckyDrawTemplateForm.container";

export default InstantLuckyDrawTemplateForm